import React from 'react';

import {
  GoogleAnalyticsConstants,
  GoogleAnalyticsDisplayedEvent,
  GoogleAnalyticsEventContextWrapper,
} from '@vvoyages/google-analytics';

import Button from '@/components/Button';
import { WizardStep } from '@/components/Wizard';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';

import styles from './ClaimBookingStep.module.scss';

type ClaimBookingSuccessProps = {
  tabId: string;
  onClickLogin: Function;
};
const ClaimBookingSuccess: React.FC<ClaimBookingSuccessProps> = ({ tabId, onClickLogin }) => {
  const appUiData = useAppUiData();
  return (
    <WizardStep tabId={tabId}>
      <GoogleAnalyticsEventContextWrapper category="VV-account-sign-in|success">
        <GoogleAnalyticsDisplayedEvent eventAction={GoogleAnalyticsConstants.EVENT_ACTION.DISPLAYED} />
        <h2 className={styles.title}>{appUiData[appUiIds.claimBooking.successPleaseLogIn]}</h2>
        <p className={styles.subtitle}>{appUiData[appUiIds.claimBooking.successSubtext]}</p>
        <Button variant="primary" onClick={onClickLogin} className={styles.buttonLogin}>
          Login
        </Button>
      </GoogleAnalyticsEventContextWrapper>
    </WizardStep>
  );
};

export default ClaimBookingSuccess;
